function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../core-video-internal';
import { PlayerType } from '../../core/player/player-type';
import { DomPlayerEngine } from '../dom-common/dom-player-engine';
import { ShakaStallDetector } from '../player-extensions/stallDetector';
import { ShakaThumbnailManager } from '../player-extensions/thumbnails/shaka-thumbnail-manager';
import { ShakaPlayerEngineItem } from './shaka-player-engine-item';
import { TimedDataGatherer } from '../player-extensions/timed-data-gatherer/timed-data-gatherer';
import { FlushMode } from '../player-extensions/timed-data-gatherer/timed-data-gatherer.enums';
export var ShakaPlayerEngine = /*#__PURE__*/ function(DomPlayerEngine) {
    "use strict";
    _inherits(ShakaPlayerEngine, DomPlayerEngine);
    function ShakaPlayerEngine(config, playerEngineOptions, debugConfig, drmConfig, thumbnailConfig, precursorEngine) {
        _class_call_check(this, ShakaPlayerEngine);
        var _this;
        _this = _call_super(this, ShakaPlayerEngine, [
            playerEngineOptions
        ]), _define_property(_this, "config", void 0), _define_property(_this, "debugConfig", void 0), _define_property(_this, "drmConfig", void 0), _define_property(_this, "thumbnailConfig", void 0), _define_property(_this, "precursorEngine", void 0), _this.config = config, _this.debugConfig = debugConfig, _this.drmConfig = drmConfig, _this.thumbnailConfig = thumbnailConfig, _this.precursorEngine = precursorEngine;
        return _this;
    }
    _create_class(ShakaPlayerEngine, [
        {
            key: "createPlayerItem",
            value: function createPlayerItem(playoutData, advertBoltOns, drmBoltOns, sessionItem, precursor) {
                var _precursor_setEngineOptions;
                var playerEngineOptions = _object_spread_props(_object_spread({}, this.playerEngineOptions), {
                    optimiseAudioTracksByLanguage: !Boolean(sessionItem === null || sessionItem === void 0 ? void 0 : sessionItem.isMultiview),
                    isMultiview: Boolean(sessionItem === null || sessionItem === void 0 ? void 0 : sessionItem.isMultiview)
                });
                precursor === null || precursor === void 0 ? void 0 : (_precursor_setEngineOptions = precursor.setEngineOptions) === null || _precursor_setEngineOptions === void 0 ? void 0 : _precursor_setEngineOptions.call(precursor, playerEngineOptions);
                return new ShakaPlayerEngineItem(this.config, playerEngineOptions, playoutData, advertBoltOns, this.getPlayerExtensions(sessionItem === null || sessionItem === void 0 ? void 0 : sessionItem.sleThumbnailConfig), drmBoltOns, precursor !== null && precursor !== void 0 ? precursor : this.precursorEngine.createPlayerItemPrecursor(playoutData, advertBoltOns, drmBoltOns, playerEngineOptions), this.debugConfig, this.drmConfig);
            }
        },
        {
            key: "getPlayerExtensions",
            value: function getPlayerExtensions(sleThumbnailConfig) {
                var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka, _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig;
                this.thumbnailConfig = _object_spread_props(_object_spread({}, this.thumbnailConfig), {
                    sleThumbnailConfig: sleThumbnailConfig
                });
                var playerExtensions = {
                    thumbnailManager: new ShakaThumbnailManager(this.thumbnailConfig)
                };
                var getStallDetector = (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig = CoreVideoInternal.getPropositionExtensions().propositionPlayerConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka = _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig[PlayerType.Shaka]) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_PlayerType_Shaka.stallDetectorFactory;
                if (getStallDetector) {
                    var stallDetector = getStallDetector();
                    return _object_spread_props(_object_spread({}, playerExtensions, stallDetector ? {
                        stallDetector: stallDetector
                    } : {}), {
                        bulkTimedMetadataGatherer: new TimedDataGatherer({
                            flushMode: FlushMode.Manual
                        })
                    });
                }
                var stallDetector1 = new ShakaStallDetector({
                    enableStallRecovery: CoreVideoInternal.deviceType === DeviceType.Tizen
                });
                return _object_spread_props(_object_spread({}, playerExtensions), {
                    stallDetector: stallDetector1,
                    bulkTimedMetadataGatherer: new TimedDataGatherer({
                        flushMode: FlushMode.Manual
                    })
                });
            }
        }
    ]);
    return ShakaPlayerEngine;
}(DomPlayerEngine);

//# sourceMappingURL=shaka-player-engine.js.map